import { Divider, Skeleton } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { TableSkeleton } from 'components/atoms/table';
import { Wrapper, HeaderSummary } from './style';

const WidgetLoader = styled(Skeleton)`
  width: 150px;
  margin-right: var(--spacing-06);
`;
const TabRow = styled.div`
  padding: var(--spacing-05);
`;

const TableWrapper = styled.div`
  margin: 0 var(--spacing-05) var(--spacing-05);
`;

export const ReportLoadingState: FC = () => (
  <Wrapper>
    <HeaderSummary>
      <WidgetLoader
        title={false}
        paragraph={{ rows: 2, width: ['100%', '80%'] }}
      />
      <WidgetLoader
        title={false}
        paragraph={{ rows: 2, width: ['100%', '80%'] }}
      />
      <WidgetLoader
        title={false}
        paragraph={{ rows: 2, width: ['100%', '80%'] }}
      />
    </HeaderSummary>
    <Divider style={{ margin: 0 }} />
    <TabRow>
      <WidgetLoader
        title={false}
        paragraph={{ rows: 1, width: ['100%', '80%'] }}
      />
    </TabRow>
    <TableWrapper>
      <TableSkeleton columnCount={8} />
    </TableWrapper>
  </Wrapper>
);
